import { RootState } from '../root.reducers';
import { CertStatus } from './certStatus.types';

export const getAllCertStatus = (state: RootState): CertStatus[] =>
  state.certStatus.entities;

export const getCertStatusByAfTypeAndLiType = (
  state: RootState,
  afType: string,
  liType: string
) => {
  const certs = state.certStatus.entities as CertStatus[];
  return certs.filter((c) => c.AFTYPE === afType && c.LITYPE === liType);
};
